import { Injectable, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { FirebaseAuthProvider } from '.';
import { SelectLanguageService } from '../../services/selectLanguage.service';
import { IProviderAuthGuard } from '@core/auth/interfaces/IProviderAuthGuard';

@Injectable({
    providedIn: 'root',
})
export class FirebaseAuthGuard implements IProviderAuthGuard {
    private provider = inject(FirebaseAuthProvider);
    private router = inject(Router);
    private selectLanguage = inject(SelectLanguageService);

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        return this.provider.isLoggedIn().pipe(
            map((isLoggedIn) => {
                if (!isLoggedIn) {
                    const lang = this.selectLanguage.get();
                    const redirectPage = lang ? '/login' : '/language';
                    this.router.navigate([redirectPage]);
                }
                return isLoggedIn;
            })
        );
    }
}
